export default __webpack_public_path__ + "static/media/grayLowTank.2f4f58dc.svg";